import { SpaceshipLoader } from "@/components/spaceship-loader/spaceship-loader";
import { useNavigate, useParams } from "react-router-dom";
import { useUserContext } from "@/contexts/user/useUserContext";
import useFetch from "@/hook/useFetch/useFetch";
import { getBenefit } from "@/services/benefits/benefit";
import { PageContainer, ContentWrapper, RedeemButton, GreenText, NormalText, FrameContainer, TextButton } from "./style-component";
import { useCallback } from "react";
import BenefitCard from "@/components/benefit-card/benefit-card";
import warningIcon from '@/assets/icons/warning-circle/warning-circle.svg';
import RedeemButtonStates from "./components/redeem-button-states";
import useRedeemGift from "./hook/useRedeemGift";

type ParamsKeys = {
    contract_address: string;
    contract_type_id: string;
    code: string;
}

const RedeemGiftPage: React.FC = () => {
    const { contract_address, code, contract_type_id } = useParams<ParamsKeys>();
    const { user } = useUserContext();
    const navigate = useNavigate();
    const { data: benefit, loading, error } = useFetch(getBenefit, { 
        contract_address: contract_address ?? '', 
        contract_type_id: contract_type_id ?? '',
        user_main_key: user?.main_key ?? undefined,
    });
    const { loading: isLoading, handleRedeem, successClaim, error: errorRedeem } = useRedeemGift();
    const disabledButton = Boolean(!contract_address || !code || isLoading);
    const handleLogin = useCallback(() => {
        navigate('/login');
    }, [navigate]);

    const handleClickRedeem = useCallback( async() => {
        if (code && contract_address) {
            await handleRedeem(code, contract_address);
        }
    }, [code, handleRedeem, contract_address])

    if (loading) return <SpaceshipLoader height="300px" />;

    if (error) return <div style={{ color: 'white' }}>¡Beneficio no encontrado!</div>;

    return (
        <PageContainer>
            <ContentWrapper>
                {!user?.username ? (       
                    <>
                        <GreenText>
                            ¡Un amigo te ha enviado un regalo!
                        </GreenText>
                        <NormalText>
                            Inicia sesión para redimir este beneficio
                        </NormalText>
                        <BenefitCard benefit={benefit?.[0]} expandable={false} />
                        <RedeemButton disabled>
                            Redimir
                        </RedeemButton>
                        <FrameContainer>
                            <img src={warningIcon} alt="warning" />
                            <NormalText>
                                Para poder redimir tu regalo primero debes{' '}
                                <TextButton onClick={handleLogin}>
                                    iniciar sesión
                                </TextButton>
                                {' '}o{' '}
                                <TextButton onClick={handleLogin}>
                                    registrarte
                                </TextButton>
                                {' '}en tpremia.
                            </NormalText>
                        </FrameContainer>
                    </>
                ) : (
                    <>
                    <GreenText>
                        ¡Un amigo te ha enviado un regalo!
                    </GreenText>
                    <NormalText>
                        Inicia sesión para redimir este beneficio
                    </NormalText>
                    <BenefitCard benefit={benefit?.[0]} expandable={false} />
                    <RedeemButtonStates
                        error={errorRedeem}
                        isLoading={isLoading}
                        disabled={disabledButton}
                        showSuccess={successClaim}
                        onRedeem={handleClickRedeem}
                    />
                </>
                )}
            </ContentWrapper>
        </PageContainer>
    );
};

export default RedeemGiftPage;